<template>
  <div class="reminder-banner">
    <img src="/img/icon-bell-filled.svg" />
    <div class="reminder-banner__text">
      <slot><!-- reminder message, to be passed in --></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReminderBanner"
}
</script>


<style lang="scss" scoped>
@import "../assets/lib";

.reminder-banner {
  display: flex;
  align-items: center;
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.05);
  background-color: #FFFFFF;
  border: 1px solid #EEECEC;
  border-radius: 56px;
  padding: 9px;
  padding-right: 40px;

  img {
    height: 58px;
    width: 58px;
    margin-top: 3px;
  }

  &__text {
    margin-left: 12px;
    font-size: 14px;

    &--bold {
      font-weight: 800;
    }

    @media screen and (min-width: $breakpoint-desktop) {
      font-size: 15px;
    }
  }
}

</style>
